
import {Component, Prop, Vue} from 'vue-property-decorator';
import session from '@/stores/Session';
import stores from '@/stores';
import {SweetModal} from 'sweet-modal-vue';
import GlobalFunctions from '@/GlobalFunctions';
import axios from 'axios';
import {showToaster} from '@/components/DashboardComposer/helpers';
// @ts-ignore
import config from '../../../src/config/config.js';
import {
  manageTranslate,
  disableSubmitButton,
  enableSubmitButton,
  resetForm,
  translate
} from '@/helpers/functions';
import moment from 'moment'

@Component({
  methods: {manageTranslate, translate},
  components: {
    SweetModal,
  },
})
export default class CreateCustomer extends Vue {

  @Prop({default: false})
  emitCreated!: boolean;

  @Prop()
  newCustomerIndex?: any;

  customersData: any = {
    salutation: null,
    firstName: '',
    title: '',
    lastName: '',
    adult: 1,
    mainGuest: 1,
    staff: false,
    languageLocalCode: '',
    accountId: '',
    locationId:1,
    checkinAt: null,
    checkoutAt: null,
    checkinTime: "11:00",
    checkoutTime: "10:00",
  }

  apiUrl = 'https://nis.devel.beta.nevron.tv/api/checkinout';
  apiTimeout = 5000;
  firstNameRules = {};
  lastNameRules = {};
  companyRules = {};
  allObject = [];
  addMoreDetail!: boolean;
  globalFunctions = new GlobalFunctions();
  renderKey = 0;


  mounted() {
    stores.Customer.getCheckIn()
      .then((response) => {
        this.allObject = response;
        // @ts-ignore
        this.allObject.languages.filter((item: any) => {
          if (item.default === 1) {
            this.customersData.languageLocalCode = item.localCode;
          }
        });
      });
    stores.Customer.getCustomerValidationRules()
      .then((response) => {
        const validationRules = response;
        if (validationRules[`first_name`]) {
          this.firstNameRules = validationRules[`first_name`];
        }
        if (validationRules[`last_name`]) {
          this.lastNameRules = validationRules[`last_name`];
        }
        if (validationRules[`location`]) {
          this.companyRules = validationRules[`location`];
        }
      });
  }

  removeContact(id: number, e: any) {
    this.customersData.contacts.splice(id, 1);
    e.preventDefault();
  }
  add() {
    // @ts-ignore
    this.customer.contacts.push({
      id: this.customersData.contacts[this.customersData.contacts.length - 1].id + 1,
      key: null,
      value: '',
      customerId: -1,
    });
  }
  submitWithDetail() {
    this.addMoreDetail = true;
    this.onSubmit();
  }
  async onSubmit(){
    if (! await this.validateForm('create-form-checkin-customer')) {
      return;
    }
// Convert to Unix timestamp
    const localDatetimeInTimestamp = moment(`${this.customersData.checkinAt}T${this.customersData.checkinTime}:00Z`, "YYYY-MM-DDTHH:mm:ssZ").unix();
    // Convert to timestamp
    const localDatetimeoutTimestamp = Math.floor(new Date(`${this.customersData.checkoutAt}T${this.customersData.checkoutTime}:00Z`).getTime() / 1000);
    const array: any = {
      "isDatabaseResync": true,
      "guests":[
        {
          "request": "in",
          "room_id": this.customersData.locationId.pmsRoomId ?? Vue.prototype.translate(this.customersData.locationId.name),
          "guest_id": null,
          "share": false,
          "checkin_type": "mn-checkin",
          "reservation_id": 1,
          "is_staff": this.customersData.staff,
          "account_id":  this.customersData.accountId ?? null,
          "guest_title": this.customersData.title !== undefined ? this.customersData.title : '',
          "guest_name": this.customersData.firstName,
          "guest_surname": this.customersData.lastName,
          "guest_isAdult": this.customersData.adult,
          "guest_canPay": true,
          "guest_language":
            {
              "type": "locale",
              "value": this.customersData.languageLocalCode
            },
          "guest_pin": 1111,
          "datetime_in": localDatetimeInTimestamp,
          "datetime_out": !isNaN(localDatetimeoutTimestamp) ? localDatetimeoutTimestamp : null
        }
      ]
    };

    const tenantName = session.project?.id || session.projectId;
    if (!tenantName) {
      showToaster('danger', 'Error', 'Project/tenant information is missing', 400, true);
      return;
    }

    let baseURL = session.project?.nisUrl || '';
    if (baseURL) {
      try {
        const urlObj = new URL(baseURL);
        // Clean the pathname to remove "undefined" and tenant name segments that shouldn't be in the base URL
        const pathParts = urlObj.pathname.split('/').filter(part =>
          part &&
          part !== 'undefined' &&
          part !== tenantName
        );
        // Reconstruct the URL with cleaned path (preserve the original path structure from NIS_URL)
        urlObj.pathname = pathParts.join('/');
        baseURL = urlObj.toString().replace(/\/$/, ''); // Remove trailing slash
      } catch (e) {
        baseURL = baseURL.replace(/\/undefined/gi, '');
        baseURL = baseURL.replace(new RegExp(`/${tenantName}(?=\/|$)`, 'gi'), '');
        if (!baseURL.match(/^https?:\/\//)) {
          showToaster('danger', 'Error', 'Invalid NIS URL configuration', 400, true);
          return;
        }
      }
    }

    if (!baseURL) {
      showToaster('danger', 'Error', 'NIS URL is not configured', 400, true);
      return;
    }

    const instance = axios.create({
      baseURL: baseURL,
      timeout: config.apiTimeout,
    });

    instance.post(`api/checkinout/${tenantName}`, array)
      .then(response => {
        this.cancel();
        stores.Language.loadTranslations();
        if (this.addMoreDetail) {
          setTimeout(() => {
            this.$router.push({name: 'customers.show', params: {id: response.data.data.id}});
          }, 2000);
        } else {
          this.$emit('created', response.data.data);
          const form = document.getElementById('create-form-checkin-customer') as HTMLFormElement;
          this.customersData = {
            salutation: '',
            firstName: '',
            title: '',
            lastName: '',
            adult: 1,
            mainGuest: 1,
            staff: false,
            languageLocalCode: '',
            accountId: '',
            locationId:1,
            checkinAt: null,
            checkoutAt: null,
            checkinTime: "11:00",
            checkoutTime: "10:00",
          }
          form.reset()
          form.classList.remove('was-validated')
        }
      })
      .catch(error => {
        if (error.response.status !== 200) {
          var body = Vue.prototype.translate(error.response.data.message);
          var name = error.response.data?.data?.body ? Vue.prototype.translate(error.response.data.data.body) : Vue.prototype.translate(error.response.data.message);

          if(body.length === 0){
            body = error.response.data.message;
          }

          if(name.length === 0){
            name = " ";
          }
          showToaster('danger',name , body, error.response.status, true);
        }
      });
  }

  cancel() {
    // Reset the form data to its initial state
    this.customersData = {
      salutation: null,
      firstName: '',
      title: '',
      lastName: '',
      adult: 1,
      mainGuest: 1,
      staff: false,
      languageLocalCode: '',
      accountId: '',
      locationId: 1,
      checkinAt: null,
      checkoutAt: null,
      checkinTime: "11:00",
      checkoutTime: "10:00",
    };

    // @ts-ignore
    this.$children[0].close();
    this.renderKey++;
  }

  setDefaultValues() {
    this.customersData.checkinAt = new Date().toISOString().substr(0, 10);

    const currentTimestamp = new Date();
    const minutes = currentTimestamp.getMinutes();
    const roundedMinutes = Math.round(minutes / 15) * 15;
    currentTimestamp.setSeconds(0);
    currentTimestamp.setMinutes(roundedMinutes);
    this.customersData.checkinTime = currentTimestamp.toTimeString().split(' ')[0];
  }

  open(){
    this.setDefaultValues();
    this.customersData.staff = false;
  }

  validateForm(formRef: string): Promise<boolean> {
    return new Promise((resolve) => {
      this.$forceUpdate();
      this.$nextTick(() => {
        const form = this.$refs[formRef] as HTMLFormElement;
        form.classList.add('was-validated');
        resolve(form.checkValidity());
      });
    });
  }
}
